
import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import App from './App';
import './index.css';
// @ts-ignore
import { registerSW } from 'virtual:pwa-register';
import { checkSessionInactivity } from './utils/sessionExpiry';

// Run session expiry check on PWA initialization (works fully offline)
checkSessionInactivity().catch(err => {
  console.error('[Auth] Initial session inactivity check failed:', err);
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

registerSW({ onNeedRefresh: () => {}, onOfflineReady: () => {} });
